import { jsx as _jsx } from "react/jsx-runtime";
import { useRouting } from '@rad/hooks/useRouting';
import NavLink from './nav-link';
import { useAuth } from '../../hooks/useAuth';
import { adminRoutesArray, buildAdminNavItems } from '../../common/routes';
const AdminSubNav = () => {
    const [routeCurrent] = useRouting();
    const [auth] = useAuth();
    const navItems = buildAdminNavItems([adminRoutesArray], auth.hasPermission);
    const isActive = (route) => route.length === 0
        ? routeCurrent.pieces.length === 0
        : route.every((seg, i) => routeCurrent.pieces[i] === seg);
    return !navItems.length ? null : (_jsx("nav", { className: "border-bottom bg-white admin-subnav", "aria-label": "Admin sections", children: _jsx("div", { className: "px-4", children: _jsx("ul", { className: "nav flex-nowrap overflow-auto justify-content-end", children: navItems.map(item => (_jsx("li", { className: "nav-item", children: _jsx(NavLink, { item: item, isActive: item.route ? isActive(item.route) : false }) }, item.key || item.href))) }) }) }));
};
export default AdminSubNav;
